import { createSlice, createEntityAdapter, PayloadAction } from "@reduxjs/toolkit";
import { BusinessReportOutcomeResult } from "@/modules/snapshots/businessReports.types";
import { RootState } from "../store";

export interface BusinessReportOutcomeResultWithDocumentName extends BusinessReportOutcomeResult {
  documentName: string;
}

const businessReportOutcomeResultAdapter = createEntityAdapter<BusinessReportOutcomeResultWithDocumentName>();

interface SnapshotCompareState {
  businessReportOutcomeResults: ReturnType<typeof businessReportOutcomeResultAdapter.getInitialState>;
}

const initialState: SnapshotCompareState = {
  businessReportOutcomeResults: businessReportOutcomeResultAdapter.getInitialState(),
};

export const snapshotCompareSlice = createSlice({
  name: "snapshotCompare",
  initialState,
  reducers: {
    addBusinessReportOutcomeResult: (state, action: PayloadAction<BusinessReportOutcomeResultWithDocumentName>) => {
      businessReportOutcomeResultAdapter.addOne(state.businessReportOutcomeResults, action.payload);
    },
    removeBusinessReportOutcomeResult: (state, action: PayloadAction<string>) => {
      businessReportOutcomeResultAdapter.removeOne(state.businessReportOutcomeResults, action.payload);
    },
    removeAllBusinessReportOutcomeResults: state => {
      businessReportOutcomeResultAdapter.removeAll(state.businessReportOutcomeResults);
    },
  },
});

export const {
  addBusinessReportOutcomeResult,
  removeBusinessReportOutcomeResult,
  removeAllBusinessReportOutcomeResults,
} = snapshotCompareSlice.actions;

// Selectors
const businessReportOutcomeResultSelectors = businessReportOutcomeResultAdapter.getSelectors<RootState>(
  state => state.snapshotCompare.businessReportOutcomeResults,
);

export const selectCompareResults = businessReportOutcomeResultSelectors.selectAll;

export default snapshotCompareSlice.reducer;
